const FETCH_BADGES = 'badgeList/FETCH_BADGES';

const FETCH_BADGE = 'badgeList/FETCH_BADGE';

const PATCH_BADGE = 'badgeList/PATCH_BADGE';

const OBTAIN_BADGE = 'badgeList/OBTAIN_BADGE';

export default {
  FETCH_BADGES,
  FETCH_BADGE,
  PATCH_BADGE,
  OBTAIN_BADGE,
};



// WEBPACK FOOTER //
// ./src/app/redux/front/badgeList/types.js